import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function ReportsRewardsModalForm({ setSpinner, close, createReport, aggregators, getAggregators }) {
  const [aggregatorId, setAggregatorId] = useState('');
  const [checkedStatuses, setCheckedStatuses] = useState([
    'OFFERED',
    'IN_PROGRESS',
    'SUCCEEDED',
    'FAILED',
  ]);

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getAggregators();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () =>
    createReport({
      aggregatorId: aggregatorId ? Number(aggregatorId) : null,
      statuses: checkedStatuses,
    });

  return (
    <>
      <Row className="align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Aggregator:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={aggregatorId}
            onChange={e => setAggregatorId(e.target.value)}
          >
            <option value="">All Standard Aggregators</option>
            {aggregators.map(agg => (
              <option key={agg.id} value={agg.id}>
                {agg.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-2 align-items-start">
        <Col md={4} className="bo-same-line">
          <Form.Label>Statuses:</Form.Label>
        </Col>
        <Col md={8}>
          <Form>
            {['OFFERED', 'IN_PROGRESS', 'SUCCEEDED', 'FAILED', 'EXPIRED'].map(x => (
              <Form.Group key={x} className="d-flex">
                <Form.Check
                  type="checkbox"
                  checked={checkedStatuses.includes(x)}
                  onChange={e =>
                    setCheckedStatuses(prev =>
                      e.target.checked ? [...prev, x] : prev.filter(y => y !== x),
                    )
                  }
                />
                <Form.Label>{x}</Form.Label>
              </Form.Group>
            ))}
          </Form>
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsRewardsModalForm;
